import { inject, observer } from 'mobx-react';
import s from './EventModal.module.scss';
import { Popup } from 'antd-mobile';
import MyIcon from '@/components/MyIcon';

const EventModal = (props) => {
    const { onClose, show } = props;
    let { simulation } = props.store;
    let { curEventData } = simulation;

    return (
        <>
            <Popup
                showCloseButton={false}
                bodyStyle={{
                    borderTopLeftRadius: '16px',
                    borderTopRightRadius: '16px',
                    overflow: 'hidden'
                }}
                onMaskClick={onClose}
                visible={show}
            >
                <div className={s.modalWrap}>
                    <div className={s.boxWrap}>
                        <div className={s.title}>
                            {/* 占位用，保持title居中 */}
                            <span className={s.closeIcon} style={{ visibility: 'hidden' }}>
                                <MyIcon type="icon-a-guanbi31" />
                            </span>
                            <span className={s.roleText}> 事件回顾</span>
                            <span onClick={onClose} className={s.closeIcon}>
                                <MyIcon type="icon-a-guanbi31" />
                            </span>
                        </div>
                        <div className={s.eventTitle}>{curEventData?.scenario_title}</div>
                        <div className={s.eventContent}>{curEventData?.scenario_description}</div>
                    </div>
                </div>
            </Popup>
        </>
    );
};

export default inject('store')(observer(EventModal));
